/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/312-arrow-down-left': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M11.5 16l-4-4L16 3.5 12.5 0 4 8.5l-4-4V16h11.5z"/>'
  }
})
